import React from 'react';
import PropTypes from 'prop-types';
import {I18nUtils} from "../../../i18n/I18nUtils";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as workImportActions from "../actions/workImportActions";

class WorkImportRow extends React.Component {

  constructor(props){
    super(props);
    this.onClickImport = this.onClickImport.bind(this);
  }

  onClickImport(work){
    this.props.workImportActions.importWork(work);
  }

  render() {
    const { work } = this.props;
    return (
      <tr>
        <td>{work.codigoObra}</td>
        <td><strong>{work.nombreAbreviadoObra}</strong></td>
        <td>
          <a
            className="btn btn-default btn-block btn-sm waves-effect waves-float"
            onClick={() => this.onClickImport(work)}
          >{I18nUtils.tr('TR_IMPORTAR')}</a>
        </td>
      </tr>
    );
  }

}

const mapDispatchToProps = dispatch => ({
  workImportActions: bindActionCreators(workImportActions, dispatch),
});

export default connect(null, mapDispatchToProps)(WorkImportRow);

WorkImportRow.propTypes = {
  work: PropTypes.objectOf(PropTypes.any).isRequired,
};

WorkImportRow.defaultProps = {
};



// WEBPACK FOOTER //
// ./src/app/works/components/WorkImportRow.js